/* eslint-disable no-shadow */
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter, faTimes, faCheck } from "@fortawesome/free-solid-svg-icons";
import {
  selectCompanyFilter,
  resetCompanyFilter,
} from "../../../actions/employerAnalyticsActions";
import {
  Wrapper,
  Filter,
  FilterTriggerWrapper,
  FilterTrigger,
  FilterTriggerInner,
  FilterOptions,
  Header,
  CloseButton,
  FilterOption,
  ResetSingleFilter,
} from "./filters-styles";

export const CompanyFilter = ({
  companyFilterShown,
  selectCompanyFilter,
  selectedCompany,
  toggleCompanyFilter,
  resetCompanyFilter,
  companiesList,
  isPremiumOrPortalUser,
  hubAdminPresent,
}) => {
  const handleCompanyNameLength = (companyName) => {
    if (companyName && companyName.length > 22) {
      return `${companyName.slice(0, 22)}...`;
    }
    return companyName;
  };

  const sortedCompaniesList = companiesList.sort((a, b) =>
    a.name.localeCompare(b.name)
  );

  return (
    <Wrapper
      id="company-filter"
      isPremiumOrPortalUser={isPremiumOrPortalUser}
      hubAdminPresent={hubAdminPresent}
    >
      <Filter>
        <FilterTriggerWrapper>
          <FilterTrigger selected={selectedCompany.name}>
            <FontAwesomeIcon
              icon={faFilter}
              onClick={() => toggleCompanyFilter()}
            />
            <FilterTriggerInner
              selected={selectedCompany.name !== null}
              onClick={() => toggleCompanyFilter()}
              id="company-filter-trigger"
            >
              {handleCompanyNameLength(selectedCompany.name) || "All Companies"}
            </FilterTriggerInner>
          </FilterTrigger>
          {(selectedCompany.name || false) && (
            <ResetSingleFilter>
              <FontAwesomeIcon
                icon={faTimes}
                onClick={() => resetCompanyFilter()}
                id="reset-company-filter"
              />
            </ResetSingleFilter>
          )}
        </FilterTriggerWrapper>
        <FilterOptions active={companyFilterShown}>
          <Header>Company</Header>
          <CloseButton
            onClick={() => toggleCompanyFilter()}
            id="close-company-filter"
          >
            <FontAwesomeIcon icon={faTimes} />
          </CloseButton>
          {sortedCompaniesList.map((company) => (
            <FilterOption
              key={company.id}
              selected={selectedCompany.id === company.id}
              id={`filter-option-${company.id}`}
              onClick={() => {
                selectCompanyFilter(company);
                toggleCompanyFilter();
              }}
            >
              {company.name}
              {selectedCompany.id === company.id && (
                <FontAwesomeIcon icon={faCheck} />
              )}
            </FilterOption>
          ))}
        </FilterOptions>
      </Filter>
    </Wrapper>
  );
};

CompanyFilter.propTypes = {
  companyFilterShown: PropTypes.bool.isRequired,
  selectedCompany: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  }).isRequired,
  selectCompanyFilter: PropTypes.func.isRequired,
  toggleCompanyFilter: PropTypes.func.isRequired,
  resetCompanyFilter: PropTypes.func.isRequired,
  companiesList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isPremiumOrPortalUser: PropTypes.bool.isRequired,
  hubAdminPresent: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  companiesList: state.employerAnalytics.companiesList,
  selectedCompany: state.employerAnalytics.selectedCompany,
  isPremiumOrPortalUser: state.employerAnalytics.isPremiumOrPortalUser,
});

export default connect(mapStateToProps, {
  selectCompanyFilter,
  resetCompanyFilter,
})(CompanyFilter);
